import React from "react";
import "./generic.scss";

export default function Loading({children, fullScreen}) {

  return (
    <div className={`loader ${fullScreen ? "fullscreen" : ""}`}>
      <div className="loader-indicator"></div>
      <div className="loader-content">
        {children}
      </div>
    </div>
  )
}
